<div>
    <div class="icon">
        <i class="fa-fw"
           [ngClass]="icon"
           aria-hidden="true">
        </i>
    </div>
    <div class="label"
         *ngIf="keyTrad"
         [innerHtml]="keyTrad | translate | tonbsp:true">
    </div>
    <div class="value-container">
        <div class="value"
             *ngIf="!value">
            <ng-content></ng-content>
        </div>
        <div class="value"
             *ngIf="value">
            {{value}}
        </div>
    </div>
</div>
